import React from 'react';

const ParentTestimonials = () => {
  return (
    <div className="testimonials-section text-center">
      <div className="container">
        <h2 className="testimonials-title">What Parents Say</h2>
        <div className="row">
          <div className="col-md-6">
            <div className="testimonial-card">
              <p className="testimonial-text">"I couldn't be more pleased with the chess instruction my daughter Adelina has received from Polonsky Academy. The instructors' passion for the game and dedication to teaching are truly remarkable. Under their guidance, my daughter's chess skills have flourished, and she has gained a deeper understanding of strategy and tactics. The academy makes learning fun and engaging, which has kept my daughter excited about chess. Their patience and ability to adapt the teaching style to suit my daughter's needs are commendable. We feel fortunate to have such talented and inspiring chess teachers. Highly recommended!"</p>
              <p className="testimonial-author">- Irina M.</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="testimonial-card">
              <p className="testimonial-text">"The instructors at Polonsky Academy have been incredible chess mentors for my 12-year-old son. Since he started working with them, my son's chess game has shot through the roof. Their passion for chess is contagious, and they've sparked an excitement in my son to play and train. My son actually outplayed his dad recently, a major triumph for our family! Even though it’s quite a challenge, my son is eagerly looking forward to the opportunity to challenge his granddad and test his skills this summer! I highly recommend Polonsky Academy; they are great role models for younger children."</p>
              <p className="testimonial-author">- Lena P.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentTestimonials;
